import React, { useState, useRef, useEffect } from "react";

const CollapsibleTaskDropdown = ({ tasks, selectedValue, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [collapsedGroups, setCollapsedGroups] = useState({
    recentlyUsed: true,
    commonlyUsed: true,
    suggestedToMe: true, // ✅ new
    others: true,
  });

  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const toggleGroup = (groupKey) => {
    setCollapsedGroups((prev) => ({
      ...prev,
      [groupKey]: !prev[groupKey],
    }));
  };

  const handleSelect = (value) => {
    onChange(value);
    setIsOpen(false);
  };

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        type="button"
        className="w-full border border-gray-300 rounded p-2 bg-white text-left"
        onClick={() => setIsOpen((prev) => !prev)}
      >
        {selectedValue || "Select Task"}
      </button>

      {isOpen && (
        <div className="absolute w-full mt-1 border border-gray-300 bg-white rounded shadow max-h-60 overflow-auto z-50">
          {/* Recently Used */}
          <div>
            <button
              type="button"
              onClick={() => toggleGroup("recentlyUsed")}
              className="w-full text-left px-4 py-2 bg-gray-100 font-semibold text-sm hover:bg-gray-200"
            >
              {collapsedGroups.recentlyUsed ? "▶" : "▼"} Recently Used
            </button>
            {!collapsedGroups.recentlyUsed &&
              tasks.recentlyUsed?.map((task, i) => (
                <div
                  key={`recent-${i}`}
                  className="px-6 py-2 hover:bg-gray-100 cursor-pointer"
                  onClick={() => handleSelect(task.shortForm)}
                >
                  {task.title}
                </div>
              ))}
          </div>

          {/* Commonly Used */}
          <div>
            <button
              type="button"
              onClick={() => toggleGroup("commonlyUsed")}
              className="w-full text-left px-4 py-2 bg-gray-100 font-semibold text-sm hover:bg-gray-200"
            >
              {collapsedGroups.commonlyUsed ? "▶" : "▼"} Commonly Used
            </button>
            {!collapsedGroups.commonlyUsed &&
              tasks.commonlyUsed?.map((task, i) => (
                <div
                  key={`common-${i}`}
                  className="px-6 py-2 hover:bg-gray-100 cursor-pointer"
                  onClick={() => handleSelect(task.shortForm)}
                >
                  {task.title}
                </div>
              ))}
          </div>

          {/* ✅ Suggested To Me (collapsible, from localStorage) */}
          {(() => {
            let suggestedTasks = [];
            try {
              suggestedTasks = JSON.parse(localStorage.getItem("tasks")) || [];
            } catch (e) {
              suggestedTasks = [];
            }
            return Array.isArray(suggestedTasks) && suggestedTasks.length > 0 ? (
              <div>
                <button
                  type="button"
                  onClick={() => toggleGroup("suggestedToMe")}
                  className="w-full text-left px-4 py-2 bg-gray-100 font-semibold text-sm hover:bg-gray-200"
                >
                  {collapsedGroups.suggestedToMe ? "▶" : "▼"} Suggested To Me
                </button>
                {!collapsedGroups.suggestedToMe && (
                  <ul className="list-disc list-inside ml-8">
                    {suggestedTasks.map((task, i) => (
                      <li
                        key={`suggested-${i}`}
                        className="py-2 hover:bg-gray-100 cursor-pointer"
                        onClick={() => handleSelect(task.shortForm)}
                      >
                        {task.title}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            ) : null;
          })()}

          {/* Others */}
          <div>
            <button
              type="button"
              onClick={() => toggleGroup("others")}
                           className="w-full text-left px-4 py-2 bg-gray-100 font-semibold text-sm hover:bg-gray-200"

            >
              {collapsedGroups.others ? "▶" : "▼"} Others
            </button>
            {!collapsedGroups.others &&
              <ul className="list-disc list-inside ml-8">
                
              {   tasks.others?.map((task, i) => (
                <div
                  key={`other-${i}`}
                   className="py-2 hover:bg-gray-100 cursor-pointer"
                        onClick={() => handleSelect(task.shortForm)}
                >
                  {task.title}
                </div>
                ))}
              </ul>
            }
          </div>
        </div>
      )}
    </div>
  );
};

export default CollapsibleTaskDropdown;
